export default class Config
{
	static showGongqi = true;
	static dataPageSize = 50;
}


// WEBPACK FOOTER //
// ./src/Config.js